import { createRouter, createWebHistory } from 'vue-router'
import layout from '../layout'
import inventory from './inventory';

const routes = [
  {
    path: '/',
    component: layout,
    children: [
      // {
      //   path: '/',
      //   name: 'dashboard',
      //   component: () => import('@/pages/dashboard')
      // },
    ],
    redirect: { name: 'stock', params: { stock: 'deposito' } }
  },
  inventory,
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
